'use client'

import React, { createContext, useContext, useState } from 'react'

export type AppContext = {
  isMobile: boolean
  distinctId: string
  hostname: string
  setDistinctId: React.Dispatch<React.SetStateAction<string>>
}

const defaultContext = {
  isMobile: true,
  distinctId: '',
  hostname: '',
  setDistinctId: () => {}
}

export const AppContext = createContext<AppContext>(defaultContext)

export default function AppContextProvider(
  { children, isMobile, hostname }: { children: React.ReactNode, isMobile: boolean, hostname: string }) {
  const [distinctId, setDistinctId] = useState('')

  return (
    <AppContext.Provider value={{ isMobile, distinctId, setDistinctId, hostname }}>
      {children}
    </AppContext.Provider>
  )
}

export function useAppContext() {
  return useContext(AppContext)
}
